import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@netfoundry-ui/shared/services';
import { firstValueFrom, Subscription } from 'rxjs';
import { IDENTITY_EXTENSION_SERVICE } from 'ziti-console-lib';
import { IdentitiesExtensionService } from '../identities-extension/identities-extension.service';

@Component({
    selector: 'netfoundry-ui-identity-conflict-details-page',
    templateUrl: './identity-conflict-details-page.component.html',
    styleUrls: ['./identity-conflict-details-page.component.scss'],
    standalone: false,
})
export class IdentityConflictDetailsPageComponent {
    private subscription = new Subscription();
    isLoading = !this.svc.conflictPageData;

    constructor(
        @Inject(IDENTITY_EXTENSION_SERVICE) public svc: IdentitiesExtensionService,
        private apiService: ApiService,
        private location: Location,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    get pageData() {
        return this.svc.conflictPageData || {
            title: 'Potential Conflicts',
            subtitle: '',
            conflictDetails: this.svc.conflictDetails || {},
            roleAttributes: [],
            emptyStateMessage: 'This identity may have conflicts, but detailed information is not available at this time.',
        };
    }

    headerActionRequested(action: any) {
        if (action?.name === 'close') {
            this.goBack();
        }
    }

    ngOnInit() {
        this.subscription.add(
            this.apiService.currentNetwork.subscribe((network: any) => {
                const identityId = this.route.snapshot.paramMap.get('id') || '';
                if (this.svc.conflictPageData) {
                    this.isLoading = false;
                    return;
                }

                if (!network?.id || !identityId) {
                    return;
                }

                this.isLoading = true;
                firstValueFrom(this.svc.getConflictDetails(network.id, identityId))
                    .then((conflictDetails: any) => {
                        this.svc.conflictDetails = conflictDetails || {};
                        this.svc.conflictPageData = {
                            title: 'Potential Conflicts',
                            subtitle: 'This identity may have potential conflicts. Please review before proceeding.',
                            conflictDetails: this.svc.conflictDetails,
                            roleAttributes: this.svc.conflictDetails?.roleAttributes || [],
                            emptyStateMessage: 'This identity may have conflicts, but detailed information is not available at this time.',
                        };
                    })
                    .catch(() => {
                        this.svc.conflictDetails = {};
                        this.svc.conflictPageData = {
                            title: 'Potential Conflicts',
                            subtitle: 'This identity may have potential conflicts. Please review before proceeding.',
                            conflictDetails: {},
                            roleAttributes: [],
                            emptyStateMessage: 'This identity may have conflicts, but detailed information is not available at this time.',
                        };
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            })
        );
    }

    goBack() {
        if (history.state?.fromConflictSourceForm) {
            this.location.back();
            return;
        }

        this.router.navigate(['../'], { relativeTo: this.route, replaceUrl: true });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
